import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-72dba59e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "loginSuccess sUTishi verify-email"
};
const _hoisted_2 = {
  class: "sUpFooter"
};
const _hoisted_3 = {
  class: "aColor"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "login-btn inbox",
  href: "mailto:gobysec@gmail.com",
  target: "_blank",
  style: {
    "text-align": "center",
    "line-height": "38px",
    "color": "#fff!important"
  }
}, "Inbox", -1));

const _hoisted_5 = {
  class: "suPColor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, [_createTextVNode(_toDisplayString(_ctx.$t("We have sent you an email to verify email account.Please login")) + " ", 1), _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.email), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t("Activate the account")), 1)]), _hoisted_4, _createElementVNode("p", _hoisted_5, [_createTextVNode(_toDisplayString(_ctx.$t("Not received yet")), 1), _createElementVNode("a", {
    class: "aColor",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.resendActiveMailFn && _ctx.resendActiveMailFn(...args))
  }, _toDisplayString(_ctx.$t("Resend")), 1)])]);
}